/* eslint-disabled */

export default class UniqProspectExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
